import { createPortal } from 'react-dom';
import IconClose from '@scramble/design-system/icons/x-close.svg';
import s from './index.module.scss';

export const ModalCenterLayout = ({ children, showClose, onClose }) => {
  return createPortal(
    <div
      className={s.wrapper}
      data-role="modal-wrapper"
      onClick={e => e.stopPropagation()}
    >
      <div
        className={s.backdrop}
        data-role="modal-backdrop"
        onClick={onClose}
      />
      <div className={s.content} data-role="modal-content">
        <div className={s.inner}>{children}</div>

        {showClose && (
          <div className={s.icon} onClick={onClose}>
            <img
              src={IconClose}
              alt="close"
              width={20}
              height={20}
              data-role="modal-close-x"
            />
          </div>
        )}
      </div>
    </div>,
    document?.body,
  );
};
